module.exports = {
    routes: [
        {
            path: '/account/:section?',
            name: 'users.account',
            component: require('./pages/Account').default,
            meta: { requiresAuth: true },
        },

        {
            path: '/overview/',
            name: 'users.overview',
            component: require('./pages/Overview').default,
            meta: { requiresAuth: true },
        },
    ],
};



// WEBPACK FOOTER //
// ./src/taskflex/users/routes.js